import React, { Component } from 'react';
import * as mat from 'material-ui';
import './style.css';
import { connect } from 'react-redux';
import dummy from '../images/Logo.jpg'
import FaPlayCircle from 'react-icons/lib/fa/play-circle'
import MdInfo from 'react-icons/lib/md/info'
import { DetailsQuiz } from '../../action/detailAction'
import { PlayOptionsAction } from '../../action/playAction';

class SearchBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            key: '',
            quizes: this.props.AllData
        }
    }
    EditQuiz(keys) {
        // console.log(keys,'keys')
        // this.props.EditMageQuiz(keys)
    }

    DeleteConfirm() {
        // this.props.DeleteQuiz(this.state.key)
        this.setState({ open: false });
    }

    DeleteQuiz(keys) {
        this.setState({ key: keys })
        this.setState({ open: true });
    };
    Details(keys) {
        this.props.DetailsQuiz(keys);
    }
    handleClose = () => {
        this.setState({ open: false });
    };
    FindMage() {
        let searchKeyword = (this.refs.searchKey.value).toLowerCase();
        // this.props.SearchBoxData(searchKeyword);
        // console.log(this.props.AllQuizs,'-------------------------');
        var filteredQuiz = {};
        for (var key in this.props.AllData) {
            if ((key).toLowerCase().search(searchKeyword) !== -1) {
                filteredQuiz[key] = this.props.AllData[key];
            }
            else if ((this.props.AllData[key].description).toLowerCase().search(searchKeyword) !== -1) {
                filteredQuiz[key] = this.props.AllData[key];
            }
            else if ((this.props.AllData[key].type).toLowerCase().search(searchKeyword) !== -1) {
                filteredQuiz[key] = this.props.AllData[key];
            }
        }
        // console.log(filteredQuiz,'filteredQuizfilteredQuizfilteredQuiz');
        this.setState({
            quizes: filteredQuiz
        })
    }
    PalyOption(keys) {
        this.props.PlayOptionsAction(keys)
    }
    render() {
        const actions = [
            <mat.FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <mat.FlatButton
                label="Delete"
                primary={true}
                keyboardFocused={true}
                onClick={this.DeleteConfirm.bind(this)}
            />,
        ];
        // const {
        //     AllData
        // } = this.props;
        let Quizs = Object.keys(this.state.quizes).map((key, index) => {
            let val = this.state.quizes[key];
            let keys = key;
            // console.log(keys,'keys')

            return (
                <mat.Card key={index} zDepth={1} style={{ marginTop: '1%', overflow: 'hidden' }}>
                    <mat.CardHeader
                        title={val.titles}
                        subtitle={<span>{val.description}</span>}
                        subtitleStyle={{ color: 'gray' }}
                        actAsExpander={true}
                        showExpandableButton={true}
                        titleStyle={{ fontSize: '2em' }}
                        avatar={<mat.Avatar
                            src={val.imgUrl === 'https' ? val.imgUrl = dummy : val.imgUrl}
                            size={70}
                        />}

                    />
                    <mat.CardText expandable={true}>
                        <mat.CardActions style={{ marginLeft: '5%' }}>
                            <mat.FlatButton
                                onClick={this.PalyOption.bind(this, keys)}
                                label='Play'
                                style={{ backgroundColor: '#00bcd4' }}
                                labelStyle={{ color: '#ffffff' }}
                                icon={<FaPlayCircle style={{ fontSize: 24, color: '#ffffff' }} />}
                            />
                            <mat.FlatButton
                                onClick={this.Details.bind(this, keys)}
                                label='Detail'
                                style={{ backgroundColor: '#00bcd4' }}
                                labelStyle={{ color: '#ffffff' }}
                                icon={<MdInfo style={{ fontSize: 24, color: '#ffffff' }} />}
                            />
                        </mat.CardActions>
                    </mat.CardText>
                </mat.Card>
            )
        }
        )
        return (
            <div>
                <mat.Paper zDepth={0} style={{ backgroundColor: '#b3d2e5' }} className='col-md-12 col-xs-12'>
                    <div style={{ marginTop: '2%' }}>
                        <div id="custom-search-input" className='col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1'>
                            <div className="input-group col-md-12">
                                <input ref='searchKey' onChange={this.FindMage.bind(this)} type="text" className="form-control input-lg" placeholder="Search" />
                                <span className="input-group-btn">
                                    <button onClick={this.FindMage.bind(this)} className="btn btn-info btn-lg" type="button">
                                        <i className="glyphicon glyphicon-search"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </mat.Paper>

                <div className='col-md-8 col-md-offset-2 col-xs-12'>
                    <mat.Card zDepth={0}>
                        {Quizs}
                    </mat.Card>
                </div>
                <mat.Dialog
                    title="Warning..!"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                >
                    <h3 style={{ color: 'red' }}>Are you ready for Delete Quiz with All Questions..!</h3>
                </mat.Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // QusetionLists: state.EditMageReducers.AllAVList,
        // sharedData: state.SahreReducers.PublicQuiz
        AllData: state.authReducers.SharedData
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        DetailsQuiz: (action) => {
            dispatch(DetailsQuiz(action));
        },
        PlayOptionsAction: (action) => {
            dispatch(PlayOptionsAction(action))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);


// WEBPACK FOOTER //
// ./src/component/search/searchMage.jsx